export const SYSTEM_REPO = 'SYSTEM';
export const READ_REPO = 'READ_REPO';
export const READ_REPO_PREFIX = 'READ_REPO_';
export const WRITE_REPO = 'WRITE_REPO';
export const MAINTAIN_REPO = 'MAINTAIN_REPO';
export const GRAPHQL = 'GRAPHQL';
export const WRITE_REPO_PREFIX = 'WRITE_REPO_';
export const MAINTAIN_REPO_PREFIX = 'MAINTAIN_REPO_';
export const GRAPHQL_PREFIX = 'GRAPHQL_';
export const GRAPHQL_SUFFIX = 'GRAPHQL';
export const SUFFIX_DELIMITER = ':';
export const GRAPHQL_SUFFIX_WITH_DELIMITER = SUFFIX_DELIMITER + GRAPHQL_SUFFIX;
export const CUSTOM_PREFIX = 'CUSTOM_';
